import styled from "styled-components";
import * as mediaQuery from "components/MediaQuery";

export const InnerPX = 40;

export const InnerPaddingWrapper = styled.div`
  padding: 0 ${InnerPX}px 0;
  ${mediaQuery.isTablet} {
    padding: 0 ${InnerPX ? InnerPX / 2 : 0}px 0;
  }
  ${mediaQuery.isMobile} {
    padding: 0 10px;
  }
`;

const InnerContainer = styled.div<{
  map?: boolean;
  fullWidth?: boolean;
  ref?: any;
}>`
  margin: 0 auto;
  height: 100%;
  padding-top: 50px;
  box-sizing: border-box;
  overflow-y: auto;

  ${mediaQuery.isDefault} {
    /* width: 90%; */
    padding: 50px 0 0;
    width: 100%;
    position: relative;

    .table-template {
      display: flex;
      flex: 1;
      flex-direction: column;
      min-height: 100%;

      > .subheader {
        flex: 0 0 auto;
      }
    }
  }
  ${mediaQuery.isMobile} {
    width: 100%;

    ${({ map }) =>
      map &&
      `
      padding: 0;
      width: 100%;
      height: 100%;
    `}
    ${({ fullWidth }) =>
      fullWidth &&
      `
      padding: 0;
    `}
  }
`;

export default InnerContainer;
